import React, { Fragment } from 'react';

import './PageContentEditor.scss';
import { updatePage } from 'RLX/State/Content/ContentActions';
import { getContentForm } from 'Core/Utils/ContentUtils';

import { uid } from 'Core/Utils/Utils';
import Icon from 'Core/Components/Icon';
import Divider from 'Core/Components/Divider';
import InfoBlock from 'RLX/Controllers/InfoBlock';
import OrderingControls from 'Core/Components/OrderingControls';
import AddPageContent from 'Dashboard/Panes/PageEditor/PageContent/AddPageContent';

class PageContentEditor extends React.Component {
  constructor (props) {
    super(props);
    this.onReorder = this.onReorder.bind(this);
    this.onContentAdd = this.onContentAdd.bind(this);
    this.onContentChange = this.onContentChange.bind(this);
    this.onContentRemove = this.onContentRemove.bind(this);
    this.renderContentSection = this.renderContentSection.bind(this);
  }

  onContentChange (newContent) {
    const { page } = this.props;
    if (!Array.isArray(newContent))
      throw new TypeError(`PageContentEditor.onContentChange: invalid newContent given (${newContent})`);
    updatePage({ ...page, content: newContent });
  }

  onReorder (index, direction) {
    if (typeof index !== 'number')
      throw new TypeError(`PageContentEditor.onReorder: index is not a number (${index})`);
    if (typeof direction !== 'string')
      throw new TypeError(`PageContentEditor.onReorder: direction is not a direction (${direction})`);

    const { page } = this.props;
    const { content } = page;
    const section = content[index];
    const contentWithoutSection = content.filter((listItem, itemIndex) => itemIndex !== index);

    switch (direction) {
      case 'start':
        return this.onContentChange([ section, ...contentWithoutSection ]);

      case 'prev':
        contentWithoutSection.splice(index - 1, 0, section);
        return this.onContentChange([ ...contentWithoutSection ]);

      case 'next':
        contentWithoutSection.splice(index + 1, 0, section);
        return this.onContentChange([ ...contentWithoutSection ]);

      case 'end':
        return this.onContentChange([ ...contentWithoutSection, section ]);

      default: return;
    }
  }

  onContentAdd (index) {
    if (typeof index !== 'number')
      throw new TypeError(`PageContentEditor.onContentAdd: "index" is not a number. (${index})`)

    return (contentType, contentDefaults) => {
      const content = [...this.props.page.content];

      if (typeof contentType !== 'string')
        throw new TypeError(`PageContentEditor.onContentAdd: "contentType" is not a string. (${contentType})`);
      if (typeof contentDefaults !== 'object')
        throw new TypeError(`PageContentEditor.onContentAdd: "contentDefaults" is not an object. (${contentDefaults})`);

      const newSection = { ...contentDefaults, type: contentType, id: uid() };
      content.splice((content.length ? index + 1 : 0), 0, newSection);
      this.onContentChange(content);
    }
  }

  onContentRemove ({ id }) {
    const { content } = this.props.page;
    const newContent = content.filter(contentSection => contentSection.id !== id);
    this.onContentChange(newContent);
  }

  renderContentSection (section, index) {
    const { page } = this.props;
    const { content } = page;
    const { type, fullWidth, id } = section;
    const EditorForm = getContentForm(type);
    const boxNumber = `${index + 1}`;
    const boxCount = boxNumber.length === 1 ? '0' + boxNumber : boxNumber;
    const moveHandler = (direction, disabled) => {
      if (disabled) return;
      return this.onReorder(index, direction);
    }
    return (
      <React.Fragment key={id}>
        <section>
          <div className="ContentSection-Gutter">
            <big>
              <b style={{ color: 'black' }}>.</b>
              {boxCount}
            </big>
            <OrderingControls
              isFirst={(index === 0)}
              isLast={(index === content.length - 1)}
              handleMove={moveHandler}
            />
          </div>
          <EditorForm
            content={section}
            page={page}
            onContentRemove={this.onContentRemove}
          />
        </section>
        <AddPageContent
          index={index}
          onContentAdd={this.onContentAdd(index)}
        />
      </React.Fragment>
    );
  }

  render () {
    const { content = [] } = this.props.page;
    if (!Array.isArray(content))
      throw new TypeError(`PageContentEditor.render: "content" is not an array. (${content})`);
    return (
      <div className="PageContentEditor">
        {!content.length
          ? <div style={{margin:'10vh 0'}}><AddPageContent index={0} onContentAdd={this.onContentAdd(0)} /></div>
          : content.map((section, index) => this.renderContentSection(section, index))
        }
      </div>
    );
  }
};

export default PageContentEditor;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Panes/PageEditor/PageContent/PageContentEditor.jsx